<template>
  <div class="switcher-wrapper">
    <div class="switcher" :class="{'one_variant': !showCouplesVariant}">
      <div
        class="switcher-item"
        :class="{ active: getSelectedConsultationType === 1 }"
        @click="setConsultationType(1)"
      >
        {{ $vuetify.lang.t("$vuetify.view.common.forMyself") }}
      </div>
      <div
        class="switcher-item"
        :class="{ active: getSelectedConsultationType === 2 }"
        @click="setConsultationType(2)"
        v-if="showCouplesVariant"
      >
        {{ $vuetify.lang.t("$vuetify.view.common.couples") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsultationTypeSwitcher',
  props: {
    showCouplesVariant: {
      type: Boolean,
      required: false,
      default: () => true,
    },
  },
  computed: {
    getSelectedConsultationType () {
      return this.$store.getters['consultation_type/getSelectedConsultationType']
    },
  },
  methods: {
    setConsultationType(consultation_type) {
      this.$store.dispatch('consultation_type/setConsultationType', consultation_type)
    },
  }
};
</script>

<style lang="scss" scoped>
.switcher-wrapper {
  display: flex;
}
.switcher {
  border: 1px solid rgb(218, 224, 229);
  border-radius: 12px;
  padding: 4px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 350px;
  gap: 4px;
}
.one_variant.switcher {
  max-width: 175px;
}
.switcher-item {
  flex-grow: 1;
  flex-basis: 40%;
  padding: 7px 20px;
  text-align: center;
  border-radius: 8px;
}
.switcher-item:hover {
  cursor: pointer;
  background: rgb(238, 241, 243);
}
.switcher-item.active {
  background: #00A3B7;
  color: #fff;
}

</style>